import { useState } from "react";
import { Link } from "react-router-dom";
import { api, apiError } from "@/lib/api";
import AuthLayout from "@/pages/auth/AuthLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
    } catch (e) {
      setError(apiError(e));
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <AuthLayout title="Check your email" subtitle="If an account exists for that email, we've sent a reset link.">
        <div className="rounded-xl border border-slate-200 bg-white p-6 text-center" data-testid="forgot-success">
          <div className="grid place-items-center h-14 w-14 rounded-2xl bg-teal/10 text-teal mx-auto mb-4"><MailCheck className="h-7 w-7" /></div>
          <p className="text-sm text-slate-600">The link is valid for 1 hour. Didn't get it? Check spam or contact your admin.</p>
          <Link to="/login" className="inline-block mt-6 text-sm font-semibold text-teal hover:underline">Back to sign in</Link>
        </div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout title="Reset your password" subtitle="Enter your email and we'll send you a reset link.">
      <form onSubmit={submit} className="space-y-5">
        <div>
          <Label htmlFor="email">Email</Label>
          <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 h-12" data-testid="forgot-email-input" autoFocus />
        </div>
        {error && <p className="text-sm text-rose-600">{error}</p>}
        <Button type="submit" disabled={loading} className="w-full h-12 bg-teal hover:bg-teal-700" data-testid="forgot-submit-btn">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Send reset link"}
        </Button>
        <Link to="/login" className="block text-center text-sm text-slate-500 hover:text-teal">Back to sign in</Link>
      </form>
    </AuthLayout>
  );
}
